var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamilyMembers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "FamilyMembers_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#304393",
    strokeWidth: 1.5,
    fill: "#304393",
    d: "M14110 251h24v24h-24z"
  })), /*#__PURE__*/React.createElement("style", null, ".FamilyMembers_svg__c{stroke:#304393;stroke-width:1.5px;fill:none;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14110 -251)",
    clipPath: "url(#FamilyMembers_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "FamilyMembers_svg__c",
    d: "M14128.077 262.022a1.082 1.082 0 101.53 0 1.082 1.082 0 00-1.53 0M14123.788 257.492a2.5 2.5 0 11-3.536 0 2.5 2.5 0 013.536 0M14126.52 268.76v-1a3 3 0 00-3-3h-3a3 3 0 00-3 3v1M14127.889 265.658h1.529c1.267 0 1.748.51 1.748 1.777v.765M14115.964 262.022a1.082 1.082 0 11-1.53 0 1.082 1.082 0 011.53 0M14116.156 265.658h-1.529c-1.267 0-1.748.51-1.748 1.777v.765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14110 251h24v24h-24z",
    fill: "none"
  }))));
}
export default SvgFamilyMembers;


//////////////////
// WEBPACK FOOTER
// ./src/icons/FamilyMembers.svg
// module id = 721
// module chunks = 13